export default {
  STEAM: 'steam',
  XBOX: 'xbox',
  PSN: 'psn',
  EPIC_GAMES: 'epicgames',
}
